export default {
    Hidden: 'hidden',
    Text: 'text',
    Select: 'select',
    DateRange: 'date-range',
    NumberRange: 'number-range',
    AsyncSelect: 'async-select'
};
